// selection.js — funciones puras para traducir entre el estado de seleccion
// interno del arbol de catalogo y la lista de recursos persistida de un agente
// (shape de escritura del endpoint /insights/agents). Se extraen aqui para que
// la pagina y el componente CatalogTree compartan la misma logica sin dependerse.
//
// Modelo de seleccion:
//   selection = {
//     "<schema>": {
//       all: boolean,                 // esquema completo seleccionado
//       tables: {
//         "<table>": {
//           all: boolean,             // tabla completa seleccionada
//           columns: string[]         // columnas puntuales (si all=false)
//         }
//       }
//     }
//   }

// Convierte el estado de seleccion interno a la lista de recursos del agente:
//   [{ schema }, { schema, table }, { schema, table, columns: [...] }]
export function selectionToResources(selection = {}) {
  const resources = [];
  Object.entries(selection).forEach(([schema, s]) => {
    if (s?.all) {
      resources.push({ schema });
      return;
    }
    Object.entries(s?.tables || {}).forEach(([table, t]) => {
      if (t?.all) {
        resources.push({ schema, table });
      } else if ((t?.columns?.length ?? 0) > 0) {
        resources.push({ schema, table, columns: [...t.columns] });
      }
    });
  });
  return resources;
}

// Reconstruye el estado de seleccion interno a partir de los recursos
// persistidos de un agente (para editar uno existente).
export function resourcesToSelection(resources = []) {
  const selection = {};
  (resources || []).forEach((r) => {
    if (!r?.schema) return;
    if (!r.table) {
      selection[r.schema] = { all: true, tables: {} };
      return;
    }
    if (!selection[r.schema]) selection[r.schema] = { all: false, tables: {} };
    if (selection[r.schema].all) return; // esquema completo ya cubre la tabla
    if (!r.columns || r.columns.length === 0) {
      selection[r.schema].tables[r.table] = { all: true, columns: [] };
    } else {
      selection[r.schema].tables[r.table] = { all: false, columns: [...r.columns] };
    }
  });
  return selection;
}
